import SmallCalendar from './component'

export default SmallCalendar
